/** @format */

import React, { useState, useEffect } from "react";
import ProviderLayout from "views/providers/Provider";
import { FadeLoader } from "react-spinners";
import AttendaceReportTable from "views/providers/components/table/fellows/AttendanceReportTable";
import {
  useGetAttendanceReportQuery,
  useExportProviderAttendanceReportQuery,
} from "store/services/providerAPI";
import { useLocation, useNavigate } from "react-router-dom";
import useApprovedProvider from "hooks/useApprovedProvider";
import { toast } from "react-toastify";
import SearchReport from "./components/SearchReport";
import { Col } from "react-bootstrap";
import { extractFilterValues } from "utils/functions";

const ProviderNewAttendanceReport = () => {
  useApprovedProvider();
  const [skip, setSkip] = useState(false);
  const [exportSkip, setExportSkip] = useState(true);

  const [search, setSearch] = useState("");
  const [searched, setSearched] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [clear, setClear] = useState(false);
  const [modalFilter, setModalFilter] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const [filter, setFilter] = useState(
    location?.search?.length > 0
      ? location?.search?.slice(1)
      : `page=1&page_size=10`
  );

  const {
    isLoading: exporting,
    isFetching: isExporting,
    isSuccess,
    isError,
  } = useExportProviderAttendanceReportQuery(filter, {
    skip: exportSkip,
  });

  const {
    data,
    isLoading: fetching,
    isFetching,
  } = useGetAttendanceReportQuery(filter, {
    skip: skip,
  });

  useEffect(() => {
    if (filter && filter.length > 0) {
      const fullPath = `${location?.pathname}?${filter}`;
      setSkip(false);
      navigate(fullPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(`✔️ Export in progress!`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setExportSkip(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      toast.error(`✔️ Export failed!`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setExportSkip(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  const metadata = data?.data?.metadata ?? "";

  const makeFilterString = (_modalFilter, _page) => {
    const queryString = `page=${_page}&page_size=${metadata?.page_size}${
      String(modalFilter?.cohort_rank ?? "")?.length > 0
        ? `&cohort_rank=${_modalFilter?.cohort_rank}`
        : ""
    }${
      String(modalFilter?.sessions ?? "")?.length > 0
        ? `&sessions=${_modalFilter?.sessions}`
        : ""
    }${
      modalFilter?.weeks?.length > 0
        ? `&weeks=${_modalFilter?.weeks.join(",")}`
        : ""
    }${
      modalFilter?.course?.length > 0
        ? `&course=${_modalFilter?.course.join(",")}`
        : ""
    }${
      modalFilter?.lga?.length > 0 ? `&lga=${_modalFilter?.lga.join(",")}` : ""
    }`;
    return queryString;
  };

  const handleAllFilter = (_modalFilter, _page) => {
    const values = extractFilterValues(_modalFilter);
    const filterString = makeFilterString(values, _page);
    setFiltered(true);
    setFilter(filterString);
    setShowFilter(false);
  };

  useEffect(() => {
    if (modalFilter) {
      setSearch("");
      handleAllFilter(modalFilter, 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalFilter]);

  // console.log('data?.data',data)

  return (
    <ProviderLayout>
      <div className="row">
        <section className="d-flex flex-column">
          <div className="d-flex align-items-center justify-content-end mb-4">
            {filter.includes("export=yes") && (
              <button
                onClick={() => {
                  setFilter(filter.replace("&export=yes", "").trim());
                  setSkip(true);
                  setExportSkip(true);
                }}
                className="btn text-danger"
              >
                Reset Export
              </button>
            )}

            <SearchReport
              data={{ exporting, isExporting, search, searched }}
              filterData={{
                modalFilter,
                clear,
                showFilter,
                filtering: fetching || isFetching,
              }}
              setSearch={setSearch}
              setSearched={setSearched}
              setFilter={setFilter}
              setExportSkip={setExportSkip}
              setModalFilter={setModalFilter}
              setClear={setClear}
              setShowFilter={setShowFilter}
            />
          </div>

          {/* <p>Filter :: {JSON.stringify(modalFilter)}</p> */}
         

          <Col xl={12}>
            <div className="d-flex  align-items-center">
              {filtered && (
                <button
                  onClick={() => {
                    setFiltered(false);
                    setFilter(
                      `page=1&page_size=${data?.data?.metadata?.page_size}`
                    );
                    setModalFilter(null);
                  }}
                  className="btn text-danger"
                >
                  Reset Filter
                </button>
              )}
            </div>
          </Col>

          {fetching ? (
            <div className="d-flex justify-content-center align-items-center height-15 bg-white ">
              <FadeLoader color="#36d7b7" />
            </div>
          ) : (
            <section className="d-flex flex-column">
              <AttendaceReportTable
                messages={data?.data?.results ?? []}
                metadata={data?.data?.metadata ?? null}
                setFilter={setFilter}
                setSkip={setSkip}
                filtering={fetching || isFetching}
                setSearch={setSearch}
                setSearched={setSearched}
                filterData={(modalFilter, clear, showFilter)}
                setModalFilter={setModalFilter}
                setClear={setClear}
                setFiltered={setFiltered}
              />
            </section>
          )}
        </section>
      </div>
    </ProviderLayout>
  );
};
export default ProviderNewAttendanceReport;
